import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import attendanceService from '../../../services/attendanceService';
import { useEmployeeSelfService } from '../../../contexts/EmployeeSelfServiceContext';
import { formatDateFromApi } from '../../../utils/attendanceDateTime';

const RegularizationSection = ({ onNotify }) => {
  const { employee, attendanceRecords, syncNow } = useEmployeeSelfService();
  const [form, setForm] = useState({
    attendance_date: '',
    request_type: 'missing_punch',
    requested_clock_in: '',
    requested_clock_out: '',
    reason: '',
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!employee?.id) return;
    setSubmitting(true);
    try {
      const result = await attendanceService.requestRegularization({
        employee_id: employee.id,
        attendance_date: form.attendance_date,
        request_type: form.request_type,
        requested_clock_in: form.requested_clock_in || null,
        requested_clock_out: form.requested_clock_out || null,
        reason: form.reason,
      });
      if (result.success) {
        onNotify?.({ message: 'Regularization request submitted', type: 'success' });
        setForm({ attendance_date: '', request_type: 'missing_punch', requested_clock_in: '', requested_clock_out: '', reason: '' });
        await syncNow();
      } else {
        onNotify?.({ message: result.error || 'Request failed', type: 'error' });
      }
    } finally {
      setSubmitting(false);
    }
  };

  const absentDays = attendanceRecords.filter((r) => r.status === 'absent' || !r.clock_in);

  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      <div>
        <h2 className="text-xl font-semibold">Attendance Regularization</h2>
        <p className="text-sm text-muted-foreground">Request corrections for missed or incorrect punches</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-card border rounded-lg p-6 space-y-4 max-w-xl">
        <div>
          <label className="text-sm font-medium">Date</label>
          <input
            type="date"
            required
            className="w-full border rounded px-3 py-2 mt-1"
            value={form.attendance_date}
            onChange={(e) => setForm({ ...form, attendance_date: e.target.value })}
          />
        </div>
        <div>
          <label className="text-sm font-medium">Request Type</label>
          <select
            className="w-full border rounded px-3 py-2 mt-1"
            value={form.request_type}
            onChange={(e) => setForm({ ...form, request_type: e.target.value })}
          >
            <option value="missing_punch">Missing Punch</option>
            <option value="correction">Time Correction</option>
            <option value="manual_entry">Manual Entry</option>
            <option value="leave_adjustment">Leave Adjustment</option>
          </select>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-medium">Clock In</label>
            <input type="time" className="w-full border rounded px-3 py-2 mt-1" value={form.requested_clock_in} onChange={(e) => setForm({ ...form, requested_clock_in: e.target.value })} />
          </div>
          <div>
            <label className="text-sm font-medium">Clock Out</label>
            <input type="time" className="w-full border rounded px-3 py-2 mt-1" value={form.requested_clock_out} onChange={(e) => setForm({ ...form, requested_clock_out: e.target.value })} />
          </div>
        </div>
        <div>
          <label className="text-sm font-medium">Reason</label>
          <textarea required rows={3} className="w-full border rounded px-3 py-2 mt-1" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} />
        </div>
        <Button type="submit" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit Request'}</Button>
      </form>

      {absentDays.length > 0 && (
        <div className="bg-muted/30 border rounded-lg p-4">
          <h3 className="text-sm font-semibold mb-2">Days that may need correction</h3>
          <div className="flex flex-wrap gap-2">
            {absentDays.slice(0, 10).map((r) => (
              <button
                key={r.id || r.attendance_date}
                type="button"
                className="text-xs bg-card border px-2 py-1 rounded hover:bg-muted"
                onClick={() => setForm((f) => ({ ...f, attendance_date: r.attendance_date?.split(' ')[0] || r.attendance_date }))}
              >
                {formatDateFromApi(r.attendance_date)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RegularizationSection;
